// saga.js
import { all, takeEvery, put, select } from 'redux-saga/effects';
import SuperFetch from '@iso/lib/helpers/superFetch';

import surveyActions from './actions';

const selectSurveys = state => state.survey;

const DEFAULT_QUERY = {
  limit: 10,
  skip: 0,
  populate: [],
  sort: '_id',
  direction: 'desc',
};

function* getSurveys({ payload }) {
  try {
    // const { users } = yield select(selectSurveys);
    const query = {
      ...DEFAULT_QUERY,
      ...payload,
    };

    const [surveys, total] = yield all([
      SuperFetch.get('/surveys', query),
      SuperFetch.get('/surveys/count', query),
    ]);

    yield put(surveyActions.setSurveys({
      surveys,
      total: total.count,
    }));

    // if (!users.length) {
      const users = yield SuperFetch.get('/users', {
        ...DEFAULT_QUERY,
        limit: 0,
      });

      yield put(surveyActions.setUsers(users));
    // }
  } catch (err) {
    yield put({
      type: surveyActions.SURVEY_ERROR,
      payload: err.message,
    }); 
  }
}

export default function* surveySaga() {
  yield all([
    takeEvery(surveyActions.GET_SURVEYS, getSurveys),
  ]);
}
